export function UserList(url,type,token){
    let baseUrl = process.env.REACT_APP_BASEAPI_URL+url;
    return new Promise((resolve, reject) =>{
        fetch(baseUrl,{
            'method':type,
            headers:{
                'Content-Type':'application/json',
                Accept:'application/json',
                Authorization:'Bearer '+token
            }
        }).then((response)=>response.json())
        .then((responseJson)=>{
            resolve(responseJson);
        }).then((error)=>{
            reject(error);
        })
    })
}

export function blockUser(type,url,token){
    let baseUrl = process.env.REACT_APP_BASEAPI_URL+url;
    return new Promise((resolve, reject) =>{
        fetch(baseUrl,{
            'method':type,
            headers:{
                'Content-Type':'application/json',
                Accept:'application/json',
                Authorization:'Bearer '+token
            }
        }).then((response)=>response.json())
        .then((responseJson)=>{
            resolve(responseJson);
        }).then((error)=>{
            reject(error);
        })
    })
}


// WEBPACK FOOTER //
// ./src/Services/User.js